<template> 
  <v-card max-width="600">
    <v-app-bar color="accent" dark rounded flat>
      <v-toolbar-title>{{ form.title }}</v-toolbar-title>
    </v-app-bar>
    <v-card-text class="mt-3">
      <v-form ref="job_form">
        <v-text-field 
          v-model="job.jobName" 
          :counter="15" 
          placeholder="ジョブ名" 
          required 
          dense 
          class="mb-3"
          :rules="[rules.required, rules.max15]">
        </v-text-field>
        <v-textarea 
          v-model="job.jobOverview" 
          :counter="50"   
          placeholder="概要"
          dense
          class="my-3"  
          :rules="[rules.required, rules.max50]">
        </v-textarea>
        <div 
          class="my-3 border-bottom" 
          @click.stop="toggleScheduleModal" 
          text 
          style="cursor: pointer;">
          <v-btn 
            color="accent" 
            depressed
            :disabled="!enableEditSchedule"
            :class="{'error--text': scheduleError, 'text-truncate': true}">
            {{ dispScheduleText }}
          </v-btn>
        </div>
        <v-combobox 
          v-model="job.categoryList" 
          label="カテゴリー"
          item-value="id" 
          item-text="name" 
          :items="categoryList" 
          hide-selected  
          return-object 
          hint="最大3つのカテゴリーを選択できます"
          :rules="[rules.required]"
          multiple 
          small-chips
          persistent-hint
          class="mt-5 mb-4"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  一致する結果がありません。 <kbd>Enter</kbd>を押して新しいカテゴリーを作成してください。 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
        <v-row>
          <v-col cols="6">
            <v-select v-model="job.jobPublishingSetting" item-text="label"  item-value="value" 
              :items="publishingSettingItems" label="公開設定" dense :rules="[rules.required]">
            </v-select>
          </v-col>
        </v-row>
        <!-- スケジュール選択用のモーダルウィンドウ -->
        <v-row>
          <v-dialog v-model=scheduleModal width="500">
            <v-card>
              <v-app-bar color="accent" dark rounded flat>
                <v-toolbar-title>実施スケジュールを選ぶ</v-toolbar-title>
              </v-app-bar>
              <v-card-text>
                <v-slider v-model="job.jobTargetContinueCount" class="mt-5" min="1" max="100" label="目標値" 
                  hint="ジョブの継続実施回数" thumb-label dense :rules="[rules.min1]">
                </v-slider>
                <v-row class="mt-5 px-5">
                  <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" 
                    transition="scale-transition" offset-y min-width="50">
                    <template v-slot:activator="{ on }">
                      <v-text-field label="開始日" v-on="on" :value="dispStartDate" v-model="job.startDate" outlined dense>
                      </v-text-field>
                    </template>
                    <v-date-picker :min="minDate" :max="maxDate" v-model="job.startDate" no-title 
                      @input="dateMenu=false">
                    </v-date-picker>
                  </v-menu>
                </v-row>
                <v-radio-group v-model="job.interval">
                  <v-radio label="毎日" value="1"></v-radio>
                  <v-radio label="日ごと" value="2"></v-radio>
                  <v-radio label="週ごと" value="3"></v-radio>
                </v-radio-group>
                <div v-show="job.interval==2">
                  <v-col cols="8" mx-auto>
                    <v-select v-model="job.dayCount" :items="dayCount" outlined dense hide-details 
                      suffix="日ごと繰り返し">
                    </v-select>
                  </v-col>
                </div>
                <div v-show="job.interval==3">
                  <v-row justify="space-around" class="px-5">
                    <v-checkbox 
                      v-for="(checkbox, index) in dayOfWeekItems" 
                      :key="index" 
                      v-model="job.dayOfWeekList" 
                      :label="checkbox.label" 
                      :value="checkbox.value" 
                      color="accent" 
                      class="mr-2" 
                      hide-details 
                    />
                  </v-row>
                </div>
                <div class="text-right">
                  <v-btn @click.stop="calcScheduleDate" color="accent">完了</v-btn> 
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>      
        </v-row>

        <div class="text-right">
          <v-btn @click="close" color="secondary" outlined class="ml-2">閉じる</v-btn>
          <v-btn @click="submit" color="accent" class="ml-2">{{ form.buttonText }}</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>

</template>
<script>
import moment from "moment";
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'JobForm',
  props: {
    editJob: Object,
    form: {
      title: String,
      subTitle: String,
      buttonText: String
    }
  },
  created(){
    // ページが描画された時に表示するジョブを変更する
    if(this.editJob.jobId){
      this.job = this.editJob;
      this.enableEditSchedule = moment(this.job.startDate).isAfter(moment());
    }
    this['category/fetchCategories']()
  },
  data (){
    return {
      scheduleModal: false,
      publishingSettingItems: [
        { label: '全体に公開', value: 1 },
        { label: '友達のみに公開', value: 2 },
        { label: '非公開', value: 3 },
      ],
      dayOfWeekItems: [
        {label: '日', value: 0},
        {label: '月', value: 1},
        {label: '火', value: 2},
        {label: '水', value: 3},
        {label: '木', value: 4},
        {label: '金', value: 5},
        {label: '土', value: 6},
      ],
      dayCount: ['1', '2', '3', '4', '5', '6'],
      rules: {
       required: v => !!v || '必須', 
       max15: v => (v || '').length <= 15 || '最大15文字',
       max50: v => (v || '').length <= 50 || '最大50文字',
       min1: v => v >= 1 || '1回以上'
      },
      scheduleError: false,
      dateMenu: false,
      minDate: moment().format("YYYY-MM-DD"),
      maxDate: moment().add(2, 'months').format("YYYY-MM-DD"),
      job: {
        startDate: this.minDate,
        dayOfWeekList: [],
        categoryList: []
      },
      enableEditSchedule: true
    }
  },
  computed: {
    dispStartDate() {
      return this.job.startDate? this.job.startDate : '';
    },
    // 実施スケジュールを表示する
    dispScheduleText(){
      moment.locale("ja");
      const defaultText = '実施スケジュールを選ぶ'
      const interval = Number(this.job.interval);
      const jobTargetContinueCount = this.job.jobTargetContinueCount;
      const dayCount = this.job.dayCount;
      const startDate = this.job.startDate;
      const dayOfWeekList = [];
      let intervalText = null;
      if(!jobTargetContinueCount || !interval || !startDate) return defaultText;
      switch(interval){
        case 1:
          intervalText = "毎日";
          break;
        case 2:
          if(!dayCount) return defaultText;
          intervalText = `${dayCount}日ごと`;
          break;
        case 3:
          if(!this.job.dayOfWeekList) return defaultText;
          this.job.dayOfWeekList.forEach(num => dayOfWeekList.push(moment().isoWeekday(Number(num)).format('dddd')));
          intervalText = `毎週・${dayOfWeekList}`;
          break;
      }
      return `${intervalText}・${startDate}開始`
    },
    ...mapGetters('category', ['categoryList'])
  },
  watch: {
    // ジョブ開始日が変更されたら、開始日の曜日を実施日に追加する
    'job.startDate'(){
      if(3 == Number(this.job.interval)){
        this.job.dayOfWeekList.push(moment(this.job.startDate).day());
      }
    },
    // ジョブの繰り返し間隔が変わった時にフォームをリセットする
    'job.interval'(){
      const interval = Number(this.job.interval);
      switch(interval){
        case 1: //毎日
          delete this.job.dayCount;
          this.job.dayOfWeekList = [];
          break;
        case 2: //日ごと
          this.job.dayOfWeekList = [];
          break;
        case 3: //週ごと
          delete this.job.dayCount;
          break;
        default:
          delete this.job.dayCount;
          this.job.dayOfWeekList.length = [];
      }
    },
    'job.categoryList'() {
      if (this.job.categoryList.length > 3) {
        this.$nextTick(() => this.job.categoryList.pop())
      }
    },
    // 2回目移行にフォームが描画された時の処理
    editJob(){
      const editJob = this.editJob;
      const startDate = editJob.startDate;
      if(editJob.jobId){
        this.job = editJob;
        this.enableEditSchedule = moment(startDate).isAfter(moment());
      } else{
        this.job = {}
        this.job.dayOfWeekList = [];
        this.job.categoryList = [];
        this.enableEditSchedule = true;
        this.$refs.job_form.resetValidation()
      }
    },
    // スケジュールのエラーが解消されたら色を元に戻す
    dispScheduleText(){
      if(this.dispScheduleText !== '実施スケジュールを選ぶ'){
        this.scheduleError = false;
      }
    }
  },
  methods: {
    toggleScheduleModal(){
      if(this.enableEditSchedule) this.scheduleModal = !this.scheduleModal;
    },
    // スケジュールからジョブ実施日を算出する
    calcScheduleDate(){
      const startDate = moment(this.job.startDate);
      const continueCount = this.job.jobTargetContinueCount;
      const interval = Number(this.job.interval);
      const dayCount = Number(this.job.dayCount);
      const dayOfWeekList = this.job.dayOfWeekList;
      const scheduledDate = {};
      // 選択したスケジュールに応じてキーに日付・値に実施状況を格納する
      scheduledDate[startDate.format("YYYY-MM-DD")] = false;
      switch(interval){
        case 1: //毎日
          for(let i = 1; i < continueCount; i++){
            scheduledDate[startDate.add(1, 'days').format("YYYY-MM-DD")] = false;
          }
          break;
        case 2: { //日ごと
          for(let i = 1; i <= continueCount; i++){
            scheduledDate[startDate.add(dayCount, 'days').format("YYYY-MM-DD")] = false;
          }
          break;
        }
        case 3: { //曜日固定
          let count = 1
          let date = startDate;
          while(count != continueCount){
            // 取得した曜日番号に一致する日付を実施日に追加する
            if(dayOfWeekList.some(dayNumber => dayNumber == date.day())){
              scheduledDate[date.format("YYYY-MM-DD")] = false;
              count++;
            }
            date = date.add(1, 'days');
          }
          break;
        }
      }
      this.toggleScheduleModal();
      this.job.scheduledDate = scheduledDate;
    },
    submit(){
      const scheduleText = this.dispScheduleText;
      if (this.$refs.job_form.validate() && scheduleText !== '実施スケジュールを選ぶ'){
        if(!this.job.jobId){
          this.job.categoryId = 1;
          this.job.groupId = null;
          this.job.jobStatus = 1;
          this['job/addMyJob'](this.job);
        } else{
          this['job/updateMyJob'](this.job);
        }
        this.$emit('close');
        this.job = {};
        this.job.dayOfWeekList = [];
        this.job.categoryList = [];
        this.$refs.job_form.reset();
      } else {
        if (scheduleText === '実施スケジュールを選ぶ') this.scheduleError = true;
        return;
      }
    },
    close(){
      this.$emit('close')
    },
    ...mapActions(['job/addMyJob', 'job/updateMyJob','category/fetchCategories'])
  },
}
</script>